export const RENAME_CLUSTER = 'RENAME_CLUSTER';

export const renameCluster = newTitle => {
  return {
    type: RENAME_CLUSTER,
    data: newTitle,
  };
};
